import { AuthGuardService } from 'src/app/auth-guard.service';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LicenseDetailsSearchComponent } from './license-details-search/license-details-search.component';
import { MyTeamDetailsSearchComponent } from './my-team-details-search/my-team-details-search.component';
import { MyTeamDetailsComponent } from './my-team-details/my-team-details.component';
import { TeamSchemeDetailsSearchComponent } from './team-scheme-details-search/team-scheme-details-search.component';
import { CountDetailsSearchComponent } from './count-details-search/count-details-search.component';

const routes: Routes = [
  {
    path: 'search-license-details',
    component: LicenseDetailsSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-my-team-details',
    component: MyTeamDetailsSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'upline-hierarchy-details/:id',
    component: MyTeamDetailsComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-team-scheme-details',
    component: TeamSchemeDetailsSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'qualified-subordinates-details/EVALUATION/:schemeName/:startDt/:endDt',
    component: CountDetailsSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'unqualified-subordinates-details/EVALUATION/:schemeName/:startDt/:endDt',
    component: CountDetailsSearchComponent,
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class HierarchyRoutingModule {}
